import del from './del';

export default {
  del,
};



// WEBPACK FOOTER //
// ./src/services/storage/index.js